import { KickAvatar } from "@components/avatar/KickAvatar";
import { BoardCardActivity } from "@design-system/Board/BoardCardActivity";

/** The agent's mark for a `BoardCardActivity` item; the row sizes it. */
export const AgentActivityIcon = () => <KickAvatar size="xs" aria-hidden />;

/** A board card's drawer while the agent works on its item: a live "Agent working" row. */
export const AgentWorkingActivity = () => (
    <BoardCardActivity
        items={[
            {
                id: "agent-working",
                icon: <AgentActivityIcon />,
                label: "Agent working",
                isLive: true,
            },
        ]}
    />
);
